import { render, staticRenderFns } from "./EcommerceCardTwo.vue?vue&type=template&id=b2fe48ea"
import script from "./EcommerceCardTwo.vue?vue&type=script&lang=js"
export * from "./EcommerceCardTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports